import React from 'react';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Link} from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import {
  hideMessage,
  showAuthLoader,
  userSignUp,
} from 'actions/Auth';
import InstitutionNativeSelect from '../app/routes/Institutions/InstitutionNativeSelect';
import SimpleSelect from '../app/routes/SimpleSelect/SimpleSelect';
import config from '../config';
import "babel-polyfill";

class SignUp extends React.Component {
  constructor() {
    super();
    this.state = {
      name: '', 
      surname:'',
      email: '',
      password: '',
      identityNo:'',
      passwordReply:'',
      institutionId : 0 ,
      titleName : '',
      sourceType : 0 , 
      nameErrorText: '', 
      surnameErrorText:'',
      emailErrorText:'',
      passwordErrorText:'',
      passwordReplyErrorText:'',
      institutionsErrorText:'Kurumunuz yok ise, yok seçeniğini veya mesleğinizi seçiniz.'
    };

    this.onChangeInstitutions = this.onChangeInstitutions.bind(this);
  }

  onChangeInstitutions = (value)=>{

    this.setState({
      institutionId : Number(value),
      institutionsErrorText:""
    });
  }
  onChangeTitle = (value)=>{

    this.setState({ 
      titleName :value==="Diğer" ? "" : value
    });
  }

  validate = ()=>{ 
    let isError = false;
    const errors = {};
    if(this.state.name.length < 1){
      isError = true;
      errors.nameErrorText = "Ad alanı zorunludur."
    }

    if(this.state.surname.length < 1){
      isError = true;
      errors.surnameErrorText = "Soyad alanı zorunludur."
    }
    
    if(this.state.email.length < 1){
      isError = true;
      errors.emailErrorText = "Mail Adresi alanı zorunludur."
    }
    if(this.state.identityNo.length !== 11){
      isError = true;
      errors.identityNoErrorText = "TC Kimlik No alanı zorunludur ve 11 Karakterdir."
    }
    if(this.state.password.length < 6){
      isError = true;
      errors.passwordErrorText = "Şifre alanı zorunludur. En az 6 karakter olmalıdır."
    }
    if(this.state.passwordReply.length < 6){
      isError = true;
      errors.passwordReplyErrorText = "Şifre Tekrar alanı zorunludur."
    }
    if(this.state.passwordReply !== this.state.password){
      isError = true;
      errors.passwordErrorText = "Şifreler uyuşmuyor."
      errors.passwordReplyErrorText = "Şifreler uyuşmuyor."
    }
    if(this.state.institutionId === 0){
      isError = true;
      errors.institutionsErrorText = "Kurum Seçimi zorunludur."
     
    }

    if(isError){
      this.setState({
        ...this.state,
        ...errors
      })
    }

    return isError;
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 3000);
    }
    if (this.props.authUser !== null) {
      this.props.history.push('/');
    }
  }

  render() {
    const {
      name,
      surname,
      email,
      password,
      passwordReply,
      institutionId,
      titleName,
      identityNo
    } = this.state;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Tümak">
              <img src={require("assets/images/tumak-logo/logo-buyuk6.png")} alt="Tümak" title="Tümak"/>
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header">
              <h1><IntlMessages id="appModule.createAccount"/></h1>
            </div>

          

            <div className="app-login-form">
              <form method="post" action="/">
                <TextField
                   error= {this.state.nameErrorText === "" ? false : true }   
                  required
                  type="text"
                  label="Ad"
                  onChange={(event) => this.setState({
                    name: event.target.value,
                    nameErrorText:""
                  })}
                  fullWidth
                  inputProps={{ maxLength: 45 }}
                  defaultValue={name}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.nameErrorText}
                />
                 <TextField
                  error= {this.state.surnameErrorText === "" ? false : true }   
                 required
                  type="text"
                  label="Soyad"
                  inputProps={{ maxLength: 45 }}
                  onChange={(event) => this.setState({surname: event.target.value,
                    surnameErrorText:""})}
                  fullWidth
                  defaultValue={surname}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.surnameErrorText}
                />
                  <TextField
                  error= {this.state.identityNoErrorText === "" ? false : true }   
                 required
                  type="text"
                  label="TC Kimlik No"
                  inputProps={{ maxLength: 11 }}
                //  maxLength={11}
                  onChange={(event) => this.setState({identityNo: event.target.value,
                    identityNoErrorText:""})}
                  fullWidth
                  defaultValue={identityNo}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.identityNoErrorText}
                />
                <SimpleSelect 
                value={this.state.titleName}
                list={config.titleList} 
                onChange={this.onChangeTitle} 
                title="Ünvan"
                />

                <TextField
                required
                  type="email"
                  error= {this.state.emailErrorText === "" ? false : true }   
                  onChange={(event) => {
                  
                    this.setState({email: event.target.value,
                      emailErrorText:""

                    })}
                  
                  }
                  label={<IntlMessages id="appModule.email"/>}
                  fullWidth
                  defaultValue={email}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.emailErrorText}
                />
                  <TextField
                  required
                  error= {this.state.passwordErrorText === "" ? false : true }   
                  type="password"
                  onChange={(event) => {
                    this.setState({password: event.target.value, 
                                  passwordErrorText:""});
                                  if(this.state.passwordReply === event.target.value)
                                    {
                                      this.setState({passwordReplyErrorText:""});
                                    }
                                
                                }
                }
                  label={<IntlMessages id="resetPassword.password"/>}
                  fullWidth
                  defaultValue={password}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.passwordErrorText}
                />
                  <TextField
                  required
                  error= {this.state.passwordReplyErrorText === "" ? false : true }   
                  type="password"
                  onChange={(event) => {
                    this.setState({passwordReply: event.target.value,
                    passwordReplyErrorText:""});
                    if(this.state.password === event.target.value)
                    {
                      this.setState({passwordErrorText:""});
                    }
                
                  
                  }
                  }
                  label={<IntlMessages id="resetPassword.passwordReply"/>}
                  fullWidth
                  defaultValue={passwordReply}
                  margin="normal"
                  className="mt-0 mb-2"
                  helperText={this.state.passwordReplyErrorText}
                />
                {/* <InstitutionsSelect
                 onChange={this.onChangeInstitutions} 
                /> */}
                {/* <InsSelect  
                 onChange={this.onChangeInstitutions}
             
                /> */}

                <InstitutionNativeSelect  
                 onChange={this.onChangeInstitutions}
                 institutionsErrorText = {this.state.institutionsErrorText}
              />


                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button variant="contained" onClick={(e) => {
                  
                    e.preventDefault();
                    const err = this.validate();
                    if(!err)
                    {
                      this.props.showAuthLoader();
                      this.props.userSignUp({email, password,name,surname,institutionId,passwordReply,titleName,identityNo});
                    }
                    
                  }} color="primary">
                    <IntlMessages
                      id="appModule.regsiter"/>
                  </Button>
                  <Link to="/signin">
                    <IntlMessages id="signUp.alreadyMember"/>
                  </Link>
                </div>
                <div className="app-social-block my-1 my-sm-3">
             
                </div> 

              </form>
            </div>
          </div>

        </div>

        {
          loader &&
          <div className="loader-view">
            <CircularProgress/>
          </div>
        }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer/>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};

export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
})(SignUp);
